import React from 'react';
import classnames from 'classnames';
import BtnClose from '../Button/BtnClose';

export default function InfoAlert({ className, text, onClose }) {
  if (onClose) {
    return (
      <div className={classnames('alert-info alert', className)}><BtnClose onClick={onClose} /> {text}</div>
    );
  }
  return (
    <div className={classnames('alert-info alert', className)}>{text}</div>
  );
}
